import {lazy, Suspense} from 'react'
import {Route} from 'react-router-dom'

import {LoadingPage} from '@pleo-io/telescope'

import {roleSets} from '@product-web/shell/user'

const RecurringVendorExpenseDetails = lazy(
    async () =>
        import('./screens/recurring-vendor-expense-details/recurring-vendor-expense-details'),
)
const RecurringVendorExpenses = lazy(
    async () => import('./screens/recurring-vendor-expenses/recurring-vendor-expenses-wrapper'),
)
const RecurringVendorsPage = lazy(
    async () => import('./screens/recurring-vendors/recurring-vendors'),
)

export const RECURRING_EXPENSES_ROUTE = 'recurring-expenses'

export const routes = (
    <Route handle={{auth: true, allowedRoles: roleSets.ownerAndBookkeeper}}>
        <Route index element={<RecurringVendorsPage />} />
        <Route path=":recurringExpensesId" element={<RecurringVendorsPage />}>
            <Route
                path=":expenseId"
                element={
                    <Suspense fallback={<LoadingPage />}>
                        <RecurringVendorExpenseDetails />
                    </Suspense>
                }
            />
            <Route
                index
                element={
                    <Suspense fallback={<LoadingPage />}>
                        <RecurringVendorExpenses />
                    </Suspense>
                }
            />
        </Route>
    </Route>
)
